import { atom, useAtom, useSetAtom } from "jotai";

export const modalAtom = atom<number[]>([]);

const useLiveShowedOrders = () => {
  return useAtom(modalAtom);
};

export const useSetLiveShowedOrders = () => useSetAtom(modalAtom);

export default useLiveShowedOrders;
